import { createContext } from 'react';

// Provided only by webserver/render.js during SSR. Route components that render a
// non-200 page (e.g. NotFound) set `statusCode` on the object so the HTTP response
// carries the same status. On the client there is no provider, so consumers get null.
// eslint-disable-next-line import/prefer-default-export
export const ServerStatusContext = createContext(null);
